var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Splash"},[_c('h1',[_vm._v("GAME OVER")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.deathText))]),_vm._v(" "),_c('p',[_vm._v("You survived "+_vm._s(_vm.daysSurvived)+" days")]),_vm._v(" "),_c('button',{staticClass:"Btn",on:{"click":_vm.newGame}},[_vm._v("\n    Start over\n  ")]),_vm._v(" "),_c('ranking')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052e856b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameOver.vue
// module id = wXef
// module chunks = 1